import { useRef, useState } from 'react';

const ARROW_KEYS = new Set(['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight']);

export interface ArrowKeyReveal<T> {
    focusOnReveal: boolean;
    choose: (next: T) => void;
    onKeyDown: (event: { key: string }) => void;
    onKeyUp: () => void;
}

/** Arrow keys move a native radio group's choice; only a click or Space may pull focus into what it reveals. */
export function useArrowKeyReveal<T>(choose: (next: T) => void): ArrowKeyReveal<T> {
    const arrowKeyHeld = useRef(false);
    const [focusOnReveal, setFocusOnReveal] = useState(false);

    return {
        focusOnReveal,
        choose: (next) => {
            setFocusOnReveal(!arrowKeyHeld.current);
            choose(next);
        },
        onKeyDown: (event) => {
            arrowKeyHeld.current = ARROW_KEYS.has(event.key);
        },
        onKeyUp: () => {
            arrowKeyHeld.current = false;
        },
    };
}
